import PrivacyPolicy from "../pages/website/PrivacyPolicy.vue";
import Terms from "../pages/website/Terms.vue";
import CookiePolicy from "../pages/website/CookiePolicy.vue";
import SitePage from "../pages/website/SitePage.vue";
import StoreLocator from "../components/locations/StoreLocator.vue";
import IndividualStore from "../pages/fly/IndividualStore.vue";
import { isValidSubdomain } from "@/utils/domainConfig";

let routes = [
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "/terms-of-use",
    name: "terms",
    component: Terms,
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: CookiePolicy,
  },
  // {
  //   path: "/",
  //   name: "site-page",
  //   component: SitePage,
  //   beforeEnter: (to, from, next) => {
  //     const hostname = window.location.hostname;
  //     const parts = hostname.split(".");

  //     // Check if this is a site subdomain
  //     if (parts[0] === "site") {
  //       next(); // Allow access to site page
  //     } else if (!localStorage.getItem("accessToken")) {
  //       next("/login"); // Redirect to login for main domain when not authenticated
  //     } else {
  //       next("/"); // Redirect to calendar for main domain when authenticated
  //     }
  //   },
  // },
  {
    path: "/:slug?",
    name: "subdomain-page",
    component: null, // Will be determined dynamically
    props: route => ({ 
      embedSlug: route.params.slug 
    }),
    meta: { embed: true, subdomain: true },
    beforeEnter: (to, from, next) => {
      const hostname = window.location.hostname;

      // Check if this is a site subdomain (store locator)
      if (isValidSubdomain(hostname, 'stores')) {
        // Dynamically set the component to StoreLocator
        to.matched[0].components.default = StoreLocator;
        to.meta.componentType = 'store-locator';
        next();
      }
      // Check if this is a landing page subdomain (individual store)
      else if (isValidSubdomain(hostname, 'landing')) {
        // Dynamically set the component to IndividualStore
        to.matched[0].components.default = IndividualStore;
        to.meta.componentType = 'landing';
        next();
      }
      // If not a valid subdomain, redirect to main site
      else {
        next("/");
      }
    },
  },
];

let websiteRoutes = routes.map((i) => {
  let meta = i.meta || {};
  meta.isWebsite = true;
  return { ...i, meta };
});

export default websiteRoutes;
